import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect, MultiSelect } from 'vue-search-select';
import Pagination from './../../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../../shared/components/customExpandableTable';
import CreateDeliveryDetails from './../CreateDeliveryDetails';
import CONSTANT from './../../../../../shared/constants/constant';
import BookingService from './../../../../services/cargobooking.service';
import MasterService from './../../../../../masterdata/services/masterdata.service';
import Util from './../../../../../shared/util/util';

export default {
  name: 'deliverydetailslisting',
  components: {
    VueElementLoading,
    BasicSelect,
    Pagination,
    CustomExpandableTable,
    CreateDeliveryDetails
  },
  props: [],
  data() {
    return {
      type: 'B2BMAEKETPLACE_DELIVERY_DETAILS',
      showCreateDeliveryDetailsData: false,
      isLoading:false,
      dcsitCode: '',
      dcsitCodeSearch: '',
      totalCount: 0,
      currentPage: 1,
      totalPage: 0,
      totalCount: 0,
      offset: 0,
      pageLimit: CONSTANT.PER_PAGE_DATA,
      tableColumn: ['DC Sit Code','Company Name', 'Email', 'Pincode',
      'Created By','Created Date','Last Modified By','Last Modified Date','Status','Action'],
      tableItems: [],
      innerTableColumn: [],
      selectedDeliveryObj: [],
      deliveryDetails:"",
      status:"",
      statusSearch:"",
      statuslist:[{
        value : "1",
        text : 'Active'
      },{
        value : "0",
        text : 'Inactive'
      }],
      statusitem:{value:'',text:''},
    }
  },
  computed: {},
  async mounted() {
    await this.getB2BMarketplaceDeliverylist();
  },
  methods: {
    selectedStatus(statusitem){
      this.statusitem = statusitem;
      this.status = this.statusitem.value;
    },
    showDeliveryData() {
      this.selectedDeliveryObj = [];
      this.showCreateDeliveryDetailsData = true;
    },
    callParent() {
        this.showCreateDeliveryDetailsData = false;
        this.selectedDeliveryObj = [];
        this.currentPage = 1;
        this.offset = 0;
        this.getB2BMarketplaceDeliverylist("");
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) *this.pageLimit
      this.getB2BMarketplaceDeliverylist();
    },
    getCustomTableEvent(event) {
      if(event.actionType=="active"){
        this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
        this.activeAction(event);
       }).catch((err)=>{
         console.log(err)
       });
     }else if(event.actionType=="inactive"){
        this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
        this.activeAction(event);
       }).catch((err)=>{
         console.log(err)
       })
      }
      if(event.actionType=="edit"){
        let selectedDeliveryObj  = this.tableArr.filter(function(Items) {
          return Items.id == event.id;
        });
        this.selectedDeliveryObj = selectedDeliveryObj[0];
        this.showCreateDeliveryDetailsData = true;
      }else if(event.actionType=="view"){
        let selectedDeliveryObj  = this.tableArr.filter(function(Items) {
          return Items.id == event.id;
        });
        this.deliveryDetails = selectedDeliveryObj[0];
      }
    },
    searchDeliveryDetails(){
      this.currentPage = 1;
      this.offset = 0;
      this.dcsitCodeSearch = this.dcsitCode;
      this.statusSearch = this.status;
      if((this.dcsitCodeSearch!="") || (this.statusSearch!="")){
      this.getB2BMarketplaceDeliverylist();
      }
    },
    resetDeliveryDetails(){
      this.currentPage = 1;
      this.offset = 0;
      this.dcsitCode= "";
      this.dcsitCodeSearch= "";
      this.status= "";
      this.statusSearch= "";
      this.statusitem = {};
      this.getB2BMarketplaceDeliverylist();
    },
    async getB2BMarketplaceDeliverylist(){
      try {
        this.isLoading = true;
        let inputPayload = {
          "offset": this.offset,
          "limit": this.pageLimit
        }
        if(this.dcsitCodeSearch!=""){
          inputPayload.dcsitcode = this.dcsitCodeSearch;
        }
        if(this.statusSearch!=""){
          inputPayload.status = this.statusSearch;
        }
        let allResolved = await Promise.all([BookingService.getB2BMarketplaceDeliverylist(inputPayload)])
        let result = allResolved[0]
        this.tableArr = result.data.data.rows;
        this.totalCount = result.data.data.count;
        if(this.totalCount>0){
          this.tableItems = result.data.data.rows.map((el)=>{
            return {
              'id':el.id,
              'DC Sit Code':el.dcsitcode,
              'Company Name':el.companyname,
              'Email': el.email,
              'Pincode': el.pincode,
              'Address':el.address,
              'ContactNo':el.contactno,
              'SPOCPer':el.spocperson,
              'GSTNo':el.gstno,
              'Created By':el.createdby,
              'Created Date':Util.displayDateTimeFormat(el.createddate),
              'Last Modified By':el.lastmodifiedby,
              'Last Modified Date':Util.displayDateTimeFormat(el.lastmodifieddate),
              'Status': el.status,
              'Action': 'Need To Check1'
            }
          })
        }else{
          this.tableItems = [];
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async activeAction(data){
      try {
        this.isLoading = true;
        var item = this.tableArr.find(item => item.id === data.id);
        var isactivestatus = item.status == 0 ? 1 : 0
        let inputPayload = {
          "id": data.id,
          "type": this.type,
          "status": isactivestatus
        }
        let result = await MasterService.changeStatus(inputPayload)
        if(result.data.code == 200){
          if(result.data.data[0].status == 0){
          this.$alert("DC Details Activated Successfully!!", this.companyname, "success");
        }else{
          this.$alert("DC Details Inactivated Successfully!!", this.companyname, "success");
         }
          this.getB2BMarketplaceDeliverylist();
          this.isLoading = false;
        }
      } catch(err){
        console.log(err);
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/B2BMarketPlace/DeliveryDetails/DeliveryDetailsListing/DeliveryDetailsListing.component.js